(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-racecar-wrap-order__main"]) return;
  try {
    
  function resizeIframe(obj) {
    $(obj).attr("height", obj.contentWindow.document.documentElement.scrollHeight +"px");
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-racecars-details__main"]) return;
  try {
    
  function resizeIframe(obj) {
    $(obj).attr("height", obj.contentWindow.document.documentElement.scrollHeight +"px");
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-windowtint-details__main"]) return;
  try {
    
  function resizeIframe(obj) {
    $(obj).attr("height", obj.contentWindow.document.documentElement.scrollHeight +"px");
  }

  } catch(e) { console.error(e); }
})();
})();
